import { PAGE_LOADED } from "./types";

export const update_page_meta = (pageMeta) => async dispatch => {
    dispatch({
        type: PAGE_LOADED,
        payload: pageMeta
    });
}